export enum LinkNames {
  profile = 'profile',
  // analytics = 'analytics',
  community = 'community',
  scheduling = 'scheduling',
  account = 'account',
}
